<template>
  <div>
  <IndexPage
    :resource="schedule"
    :disable_delete_all="schedule.items.filter((item) => item.generator && item.generator === 'configure-app').length > 0"
    calss="schedules list-page"
    data-test-id="schedules-list-page"
  >
      <template v-slot:filters>
        <FormInput :label="l.t('app.name', 'Name')">
          <w-text-field v-model="schedule.filters.name" hide-details='auto' data-test-id="schedules-filters-name-input"/>
        </FormInput>
      </template>
      <template v-slot:list>
        <v-simple-table class="list-table" data-test-id="schedules-table">
          <thead data-test-id="table-head">
            <tr data-test-id="head-row">
              <th data-test-id="checkbox"></th>
              <th data-test-id="name">{{l.t('app.name', 'Name')}}</th>
              <th data-test-id="id">{{l.t('app.id', 'ID')}}</th>
              <th data-test-id="more-options"></th>
            </tr>
          </thead>
          <tbody data-test-id="table-body">
            <tr
              v-for="(item, i) in schedule.items"
              :key="item['id']"
              :class="{'selected-row': item.selected}"
              :data-test-id="`schedules-item-${i}-row`"
            >
              <td class="select-table-item" data-test-id="checkbox">
                <DisabledCheckbox
                  v-if="item.generator && item.generator === 'configure-app'"
                  :data-test-id="`schedules-item-${i}-checkbox-tooltip-activator`"
                >
                  <template v-slot:label>
                    {{l.t('schedules.cofigure-holiday', 'Configure holiday can\'t be deleted.')}}
                  </template>
                </DisabledCheckbox>
                <w-checkbox
                  v-else
                  v-model="item.selected"
                  @click="checked($event, item)"
                  :key="`schedules-item-${item.id}-${item.selected}`"
                  hide-details="auto"
                  :data-test-id="`schedules-item-${i}-checkbox`"
                />
              </td>
              <td class="nowrap overflow-hidden" data-test-id="link">
                <IndexListItem
                  :route="{
                    name: 'schedules.show',
                    params: {
                      id: item.id,
                      _schedule: item,
                    },
                  }"
                  :item="item"
                  :title="item.name"
                  :key="item['id']"
                  :data-test-id="`schedules-item-${i}-title`"
                />
              </td>
              <td class="w-100" :data-test-id="`schedules-item-${i}-id`">
                #{{ item['id'] }}
              </td>
              <td data-test-id="more-options">
                <MoreOptions :options="more_options(item)" />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
  </IndexPage>
  <ConfirmDeletion
      :value="!!deleting_item_id"
      @closed="deleting_item_id = null"
      @confirmed="schedule.delete_item(deleting_item_id)"
    />
  </div>
</template>

<script>
  import { vueComponent } from '../../../libs/helpers2';
  import l from '../../../libs/lang';
  import Schedule from '../../../models/Schedule';
  import IndexPage from '../../elements/IndexPage.vue';
  import MoreOptions from '../../elements/MoreOptions.vue';
  import FormInput from '../../elements/form/FormInput.vue';
  import IndexListItem from '../../elements/IndexListItem.vue';
  import DisabledCheckbox from '../../elements/DisabledCheckbox.vue';
  import ConfirmDeletion from '../../elements/modal/ConfirmDeletion.vue';

  export default {
    components: {
      FormInput,
      IndexPage,
      MoreOptions,
      IndexListItem,
      ConfirmDeletion,
      DisabledCheckbox,
    },
    data() {
      return {
        l,
        deleting_item_id: null,
        schedule: new Schedule(this.$session, vueComponent(this)),
      };
    },
    async mounted() {
      this.$parent.$on('userRedirected', (to, from, next) => {
        this.$data.schedule.handleUserRedirect(to, from, next);
      });
    },
    methods: {
      more_options(item) {
        const options = [
          {
            cb: () => this.$router.push({
              name: 'schedules.show',
              params: {
                id: item.id,
                _queue: item,
              },
            }),
            title: l.t('app.edit', 'Edit')
          }
        ];
        if (!(item.generator && item.generator === 'configure-app')) {
          options.push({
            cb: () => this.$data.deleting_item_id = item.id,
            title: l.t('app.delete', 'Delete'),
          });
        }
        return options;
      },
      checked(event, item) {
        this.$data.schedule.checked(event, item);
        this.$emit('forceUpdate');
      }
    }
  };
</script>
